import React from 'react';
import { useNavigate } from 'react-router-dom';
import SiteHeader from '../../components/SiteHeader/SiteHeader';
import ContactCenterSection from '../../components/landing/ContactCenterSection';
import styles from './SobreNosotrosPage.module.css';

const VALORES = [
  'Profesionalismo',
  'Compromiso',
  'Confianza',
  'Respeto',
  'Trabajo en equipo',
];

function SobreNosotrosPage() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <SiteHeader />

      {/* ── Intro ── */}
      <section className={styles.intro}>
        <div className={styles.introInner}>
          <div className={styles.introLeft}>
            <img src="/logos/logos_4.png" alt="ODM" className={styles.introLogo} />
            <h1 className={styles.introTitle}>
              Educación en línea con propósito y visión profesional
            </h1>
            <p className={styles.introText}>
              ODM es una institución mexicana de educación superior 100% en
              línea, con más de 15 años de experiencia formando profesionales
              comprometidos con su crecimiento académico y laboral.
            </p>
            <p className={styles.introTextBold}>
              Creemos que la educación no solo abre oportunidades, sino que
              transforma trayectorias. Por eso desarrollamos programas
              accesibles, flexibles y orientados a la aplicación real en el
              entorno empresarial.
            </p>
            <button
              type="button"
              className={styles.introCta}
              onClick={() => navigate('/inscripcion')}
            >
              Comenzar inscripción
            </button>
          </div>
          <div className={styles.introRight}>
            <img
              src="/Nosotros/Ilustracion 1.png"
              alt="Educación en línea ODM"
              className={styles.introIlustration}
            />
          </div>
        </div>
      </section>

      {/* ── Misión ── */}
      <section className={styles.mision}>
        <div className={styles.misionInner}>
          <div className={styles.misionLeft}>
            <img
              src="/Nosotros/Ilustración 2.png"
              alt="Nuestra misión"
              className={styles.misionIlustration}
            />
          </div>
          <div className={styles.misionRight}>
            <p className={styles.misionEyebrow}>Nuestra misión</p>
            <h2 className={styles.misionTitle}>
              Formar profesionales preparados para un entorno cambiante
            </h2>
            <p className={styles.misionText}>
              Impulsamos el desarrollo profesional a través de programas
              académicos innovadores, con validez oficial SEP, integrando
              herramientas digitales, pensamiento estratégico y desarrollo
              humano.
            </p>
            <p className={styles.misionText}>
              Nuestro compromiso es ofrecer una educación de alto impacto que
              permita a cada estudiante avanzar en su carrera sin detener su
              vida laboral.
            </p>
          </div>
        </div>
      </section>

      {/* ── Formación humanista ── */}
      <section className={styles.humanista}>
        <div className={styles.humanistaInner}>
          <div className={styles.humanistaLeft}>
            <h2 className={styles.humanistaTitle}>
              Formación humanista aplicada
            </h2>
            <p className={styles.humanistaText}>
              Vivimos en un entorno empresarial dinámico, competitivo y en
              constante transformación. En ODM entendemos que el conocimiento
              técnico debe ir acompañado de habilidades humanas.
            </p>
            <p className={styles.humanistaText}>
              Por ello, nuestros programas integran liderazgo, inteligencia
              emocional, comunicación efectiva y gestión estratégica del
              talento, fortaleciendo tanto el crecimiento profesional como el
              desarrollo personal.
            </p>
            <p className={styles.humanistaTextBold}>
              Formamos personas capaces de liderar, adaptarse y generar valor
              en las organizaciones.
            </p>
          </div>
          <div className={styles.humanistaRight}>
            <img
              src="/Nosotros/Ilustración 3.png"
              alt="Formación humanista"
              className={styles.humanistaIlustration}
            />
          </div>
        </div>
      </section>

      {/* ── Valores ── */}
      <section className={styles.valores}>
        <div className={styles.valoresInner}>
          <h2 className={styles.valoresTitle}>Nuestros valores</h2>
          <p className={styles.valoresDesc}>
            Nuestra comunidad académica se construye sobre principios sólidos.
            Estos valores guían nuestra forma de enseñar, acompañar y formar
            líderes preparados para enfrentar los desafíos actuales.
          </p>
          <div className={styles.valoresRow}>
            {VALORES.map((v) => (
              <div key={v} className={styles.valorCircle}>
                <span className={styles.valorLabel}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ContactCenterSection />
    </div>
  );
}

export default SobreNosotrosPage;
